import { EyeIcon, EyeOffIcon } from "lucide-react";
import { type ComponentPropsWithRef, useState } from "react";

import { InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput } from "../input-group";
import { cn } from "../lib/utils";

export function PasswordInput({ className, ...props }: ComponentPropsWithRef<"input">) {
	const [showPassword, setShowPassword] = useState(false);

	const Icon = showPassword ? EyeOffIcon : EyeIcon;

	return (
		<InputGroup>
			<InputGroupInput
				type={showPassword ? "text" : "password"}
				className={cn("pr-10", className)}
				{...props}
			/>
			<InputGroupAddon>
				<InputGroupButton
					className="absolute right-2 top-1/2 -translate-y-1/2 z-10 p-1 cursor-pointer hover:bg-muted rounded-md"
					onClick={() => setShowPassword((p) => !p)}
				>
					<Icon className="h-4 w-4" />
				</InputGroupButton>
			</InputGroupAddon>
		</InputGroup>
	);
}
